export default __webpack_public_path__ + "static/media/google-icon.eecddc31.png";